import { NotFoundError } from '@cian/peperrors/shared';

import { TGetComparisonDesktopResponse } from '../../../repositories/offers-comparison/v2/get-comparison-desktop';

export const assertNotFoundError = (response: TGetComparisonDesktopResponse): void => {
  if (response.statusCode !== 400) {
    return;
  }

  const { message, errors } = response.response;

  throw new NotFoundError({
    domain: 'src/node/services/compare/fetchComparison.ts',
    message: message || '',
    details: {
      errors,
    },
  });
};
